import { render, staticRenderFns } from "./SigningUpCertificateCustomer.vue?vue&type=template&id=29ac60d5&scoped=true"
import script from "./SigningUpCertificateCustomer.vue?vue&type=script&lang=ts"
export * from "./SigningUpCertificateCustomer.vue?vue&type=script&lang=ts"
import style0 from "./SigningUpCertificateCustomer.vue?vue&type=style&index=0&id=29ac60d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ac60d5",
  null
  
)

export default component.exports